var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50016 4.08333C1.89191 4.08333 0.583496 4.93208 0.583496 5.97567V7H6.41683V5.97567C6.41683 4.93208 5.10841 4.08333 3.50016 4.08333ZM8.75016 1.75C8.75016 2.71483 9.53533 3.5 10.5002 3.5C11.465 3.5 12.2502 2.71483 12.2502 1.75C12.2502 0.785167 11.465 0 10.5002 0C9.53533 0 8.75016 0.785167 8.75016 1.75ZM10.5002 4.08333C8.89191 4.08333 7.5835 4.93208 7.5835 5.97567V7H13.4168V5.97567C13.4168 4.93208 12.1084 4.08333 10.5002 4.08333ZM5.25016 1.75C5.25016 0.785167 4.465 0 3.50016 0C2.53533 0 1.75016 0.785167 1.75016 1.75C1.75016 2.71483 2.53533 3.5 3.50016 3.5C4.465 3.5 5.25016 2.71483 5.25016 1.75Z",
    fill: "#5F698B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.7ef48b5b82a053e26c557b1ff016b2b9.svg";
export { ForwardRef as ReactComponent };